export default __webpack_public_path__ + "static/media/technology-bluetooth.5430c8a0.svg";